import { render, staticRenderFns } from "./purchase-unit-select.vue?vue&type=template&id=2e3754a0&scoped=true&"
import script from "./purchase-unit-select.vue?vue&type=script&lang=ts&"
export * from "./purchase-unit-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3754a0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3754a0')) {
      api.createRecord('2e3754a0', component.options)
    } else {
      api.reload('2e3754a0', component.options)
    }
    module.hot.accept("./purchase-unit-select.vue?vue&type=template&id=2e3754a0&scoped=true&", function () {
      api.rerender('2e3754a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/purchase-unit-select.vue"
export default component.exports